import React, { Component } from 'react'
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import logo from '../assets/images/logo.png'

// import appSettings from '../assets/app-settings.json'

export class NavBarTop extends Component {
    render() {
        const appSettings = window.AppConfigSettings;
        return (
            <Navbar expand="md" className="navbar  border-bottom border-primary border-10" >
                <Container fluid>
                    <Navbar.Brand href="./" className="navbar-brand-text " >
                        <img className="brand-image" src={logo} alt="CHRGIS-TAMUCC" />{' '}
                        CHRGIS Data
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto navbar-nav ">
                            <Nav.Link href="./" className="nav-link nav-item active hover-underline">Home</Nav.Link>
                            <Nav.Link href="./about" className="nav-link nav-item hover-underline">About</Nav.Link>
                            <NavDropdown title="CHRGIS" id="basic-nav-dropdown" className="hover-underline">
                                {appSettings["NavUrlLinks"].map((item) => {
                                    return <NavDropdown.Item href={item.url} key={item.id} target="_blank" >{item.label}</NavDropdown.Item>
                                })}
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="./about#sponsors">Sponsors</NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        )
    }
}

export default NavBarTop
